import { SAArtwork } from 'types/Artwork'
import {
  ConstructorResultsDataGroupObject,
  GetAspectRatioParams,
  TransformConstructorSearchResultsParams,
} from '../../constructorTypes'

const getCategoryFromGroups = (
  groups: ReadonlyArray<ConstructorResultsDataGroupObject>
): string => {
  const categoryArray = groups
    .map(({ display_name }) => display_name)
    .filter((categoryName) => categoryName?.toLowerCase() !== 'all')
  return categoryArray?.[0] || ''
}

const getAspectRatio = ({
  isPrintsPage,
  aspectRatio,
  printAspectRatio,
}: GetAspectRatioParams): number => {
  const defaultAspectRatio = 1

  if (isPrintsPage) {
    return printAspectRatio || defaultAspectRatio
  }
  return aspectRatio || defaultAspectRatio
}

export const transformConstructorSearchResults = ({
  searchRequest,
  searchResults,
  destinationZone,
}: TransformConstructorSearchResultsParams): ReadonlyArray<Partial<SAArtwork>> => {
  const { num_results_per_page: hitsPerPage = 100, page = 1 } = searchRequest || {}

  return searchResults.map(({ data, value }, index) => {
    const {
      artist_first_name,
      artist_last_name,
      country,
      depth,
      geo_prices,
      height,
      id,
      groups,
      image_url,
      is_ready_to_hang,
      materials,
      mediums,
      orientation,
      styles,
      subject,
      url,
      variation_id,
      width,
      artist_profile_url,
      image_aspect_ratio,
      print_image_aspect_ratio,
      print_min_price,
      print_materials,
      print_size_bins,
      print_frames,
    } = data
    return {
      artworkTitle: value,
      imageBaseUrl: image_url,
      country,
      firstName: artist_first_name,
      lastName: artist_last_name,
      productUrl: url,
      sku: variation_id ?? '--', // To avoid GTM error
      orientation,
      subject,
      styles,
      materials,
      mediums,
      artworkId: Number(id),
      positionID: hitsPerPage * page + (index + 1),
      width,
      height,
      depth,
      listPrice: geo_prices?.[destinationZone],
      isReadyToHang: is_ready_to_hang ? 1 : 0,
      profileUrl: artist_profile_url,
      category: getCategoryFromGroups(groups),
      aspectRatio: getAspectRatio({
        isPrintsPage: Boolean(print_min_price),
        aspectRatio: image_aspect_ratio,
        printAspectRatio: print_image_aspect_ratio,
      }),
      originalStatus: 'avail', // Missing in constructor
      minPrintPrice: print_min_price,
      hasPrint: Boolean(print_min_price),
      hasOpenEditions: Boolean(print_min_price),
      printUrl: url, // need to format to include '/print'
      printMaterials: print_materials,
      printSizes: print_size_bins,
      printFrames: print_frames,
    }
  })
}
